class ShareholderLetter {
  constructor() {
    this.blocks = Array.prototype.slice.call(document.querySelectorAll('[data-shareholder-letter]'));

    if (this.blocks.length) {
      this.blocks.forEach((block) => this.init(block));
    }
  }

  init(block) {
    const toggle = block.querySelector('[data-shareholder-letter-toggle]');
    const more = block.querySelector('[data-shareholder-letter-more]');

    if (!toggle || !more) {
      return;
    }

    more.style.height = '0px';
    more.style.overflow = 'hidden';
    this.syncLabels(block, false);

    toggle.addEventListener('click', () => {
      if (block.classList.contains('is-open')) {
        this.close(block, toggle, more);
      } else {
        this.open(block, toggle, more);
      }
    });
  }

  open(block, toggle, more) {
    block.classList.add('is-open');
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    more.classList.add('is-open');
    this.syncLabels(block, true);
    this.slideOpen(more);
  }

  close(block, toggle, more) {
    block.classList.remove('is-open');
    toggle.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    more.classList.remove('is-open');
    this.syncLabels(block, false);
    this.slideClose(more);
  }

  syncLabels(block, isOpen) {
    const moreLabel = block.querySelector('.lc-shareholder-letter__toggle-label--more');
    const closeLabel = block.querySelector('.lc-shareholder-letter__toggle-label--close');

    if (moreLabel) {
      moreLabel.hidden = isOpen;
      moreLabel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    }

    if (closeLabel) {
      closeLabel.hidden = !isOpen;
      closeLabel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }
  }

  slideOpen(elem) {
    if (elem._slideAnimation) {
      elem._slideAnimation.cancel();
    }

    elem.style.overflow = 'hidden';
    elem.style.height = '0px';
    // Force layout so scrollHeight is reliable from the collapsed state
    void elem.offsetHeight;
    const target = `${elem.scrollHeight}px`;

    const animation = elem.animate(
      [{ height: '0px' }, { height: target }],
      { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
    );
    elem._slideAnimation = animation;

    animation.onfinish = () => {
      elem.style.height = 'auto';
      elem.style.overflow = 'hidden';
      animation.cancel();
      elem._slideAnimation = null;
    };
  }

  slideClose(elem) {
    if (elem._slideAnimation) {
      elem._slideAnimation.cancel();
    }

    const current = `${elem.scrollHeight}px`;
    elem.style.overflow = 'hidden';
    elem.style.height = current;
    void elem.offsetHeight;

    const animation = elem.animate(
      [{ height: current }, { height: '0px' }],
      { duration: 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
    );
    elem._slideAnimation = animation;

    animation.onfinish = () => {
      elem.style.height = '0px';
      animation.cancel();
      elem._slideAnimation = null;
    };
  }
}

export default ShareholderLetter;
